<file-manager [initialPath]="initialPath" [featureKey]="'MARKETING_FILE_MANAGER'"></file-manager>

